<template>
  <div :class="show ? 'menu-fixed' : ''">
    <div v-if="( $route.path !='/home')" style="height:45px"></div>
    <div class="header-box clearfix" v-if="!show" :class="($route.path =='/home') ? '' : 'menu-other'">
      <div class="o_v top">
        <ul class="fl">
          <li class="fl">
            <span class="icon-phone"><img src="./../../assets/img/icon_phone_home.png" alt="" srcset=""></span>
            +86-021-33238888
          </li>
          <li class="fl" style="letter-spacing: 1.17px;">订房帮助</li>
        </ul>
        <ul class="fr">
          <!-- <li class="fl" style="letter-spacing: 1.17px;cursor: pointer;" @click="toRoom()">立即预定</li>
          <li class="fl icon-wechat">
            <img @mouseenter="enterCode()" @mouseleave="leaveCode()" src="./../../assets/img/icon_weixin_home.png" alt="" srcset="">
          </li> -->
          <li class="fl icon-logo" @click="setUrl('home')"><img src="./../../assets/img/icon_tap_logob_home.png" alt="" srcset=""></li>
        </ul>
      </div>
    </div>
    <div :class="isCodeShow ? 'code' : ''" v-if="isCodeShow">
      <div style="position: relative;width: 1200px;">
        <div class="QRcode">
          <div class="ORcode__on ta_c">
            <img src="http://www.lvshouhotel.com/lvshouhotel/QRcode.png" alt="" srcset="">
          </div>
        </div>
      </div>
      
    </div>
    <div :class="($route.path == '/room'|| $route.path =='/home') ? '' : 'is-menu-shadow'">
      <div class="menu clearfix">
        <img class="logo" v-if="show" width="150" src="./../../assets/img/icon_tap_logo_a.png" alt="">
        <ul class="nav clearfix">
          <!-- @click="setUrl(item.path,'menu')" -->
          <!-- :class="$route.path == item.path ? 'menu-item-on' : ''" -->
          <li
              class="fl ta_c menu-item"
              :class="getClassNameFn(item)"
              v-for="item in routes"
              :index="item.meta.showMenuItem"
              :key="item.meta.showMenuItem"
              v-if="item.meta.isShow"
              @click="setUrl(item.path)"
              :style="{opacity:$route.path ==item.path?'1':'0.7' }">
              <span class="en-title">{{item.meta.titleEn}}</span>
              <span class="title">{{item.meta.title}}</span>
          </li>
        </ul>
        <button class="btn-add fr" v-if="show" @click="toRoom()">预订</button>
      </div>
    </div>
    
  </div>
</template>
<script>
import { routes } from "./../../router";

export default {
  props: {
    show: {
      type: Boolean,
      defalut: false
    }
  },
  name:'banner',
  data(){
    return{
      routes,
      isCodeShow: false
    }
  },
  mounted(){
    
  },
  methods:{
    getClassNameFn(data) {
      let _classStr = "";
      if (this.$route.path.indexOf(data.path) != -1) {
        _classStr = "menu-item-on";
      }
      return _classStr;
    },
    setUrl(url) {
      //导航菜单跳转路由方法
      this.$router.push(url);
      
    },
    toRoom(){
      let routeUrl = this.$router.resolve({
            path: "/room",
      });
      window.open(routeUrl .href, '_blank');
    },
    enterCode(){
      this.isCodeShow = true;
    },
    leaveCode(){
      this.isCodeShow = false;
    }
  }
}
</script>
<style>
@keyframes a {
    0% {
        opacity: 0;
        -webkit-transform: translateY(-400px);
        transform: translateY(-400px)
    }

    to {
        opacity: 1;
        -webkit-transform: translateY(0);
        transform: translateY(0)
    }
}
.menu-fixed{
height: 154px;
background:  rgba(19, 20, 21, .97);
position: fixed;top: 0;z-index: 1002;left: 0;width: 100%;
  -webkit-animation: a 1s ease forwards 0s;
    animation: a 1s ease forwards 0s;
}

</style>

<style lang="less">
.code{
  width: 1200px;
  margin: 0 auto;
  position: fixed;
  z-index: 2002;
  height: 200px;
  left: 50%;
  transform: translateX(-50%);
  .QRcode{
    width: 180px;
    height: 190px;
    // background: #FFFFFF;
    position: absolute;
    top: 0;
    right: 77px;
    z-index: 2001;
  }
  .ORcode__on {
    position: relative;
    width: 100%;
    height: 180px;
    background-color: #FFFFFF;
    margin-top: 15px;
    color: #FFFFFF;
    text-align: center;
    font-size: 14px;
    line-height: 33px;
    box-sizing: border-box;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    border-radius: 4px;
    box-shadow: 0px 1px 3px #ccc;
    img{
      position: relative;
      z-index: 2003;
      top: 10px;
      width: 160px;
    }
  }
  .ORcode__on:after {
      position: absolute;
      content: "";
      left: 50%;
      top: 0px;
      display:block;
      width: 22px;
      height: 20px;
      background: #fff;
      transform: rotate(45deg) translateX(-50%);
      border-radius: 4px;
  }
}

/* 头部样式 */
.header-box{
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 45px;
  line-height: 45px;
  opacity: 0.95;
  background: #000000;
  color: #FFFFFF;
  z-index: 2;
  font-size: 12px;
  
  .icon-phone{
    width: 16px;
    display: inline-block;
    margin-right: 5px;
    img{
      position: relative;
      top: 5px;
      width: 100%;
    }
  }
  .icon-wechat{
    width: 20px;
    margin: 0 56px 0 56px !important;
    img{
      position: relative;
      top: 8px;
      width: 100%;
      cursor: pointer;
    }
    
  }
  .icon-logo{
    img{
      position: relative;
      top: 6px;
      width: 100%;
      cursor: pointer;
    }
  }
  .top{
    width: 1200px;
    margin: 0 auto;
    ul{
      li+li{
        margin-left: 10px;
      }
    }
  }
  
}
.menu{
  width: 1200px;
  margin: 0 auto;
  position: relative; 
  .logo{
    display: block;
    margin: 22px auto 0;
  }
  .btn-add{
    width: 180px;
    height: 40px;
    border: 1px solid #FFFFFF;
    border-radius: 2px;
    background: transparent;
    color: #FFFFFF;
    letter-spacing: 5px;
    margin: 12px 0;
    cursor: pointer;
  }
  .btn-add:focus{
    outline: none;
  }
}
.nav{
  z-index: 999;
  position: absolute;
  padding: 15px 0;
  left: 2%;
  background: rgba(0, 0, 0, 0);
  width: 1000px;
  .menu-item{
    cursor: pointer;
    width:auto;
    position: relative;
    color: #fff;
    margin-right: 40px;
    line-height: 32px;
    .title{
      letter-spacing: 1.17px;
      margin-left: 10px;
      font-size: 12px;
    }
    &:last-child{
      margin-right: 0px;
    }
    &:hover .submenu{
      display: block;
    }
    .submenu{
      display: none;
      color: #333;
      line-height: 20px;
      
    }
  }
  // .menu-item.menu-item-on::after{
  //   content: " ";
  //   display: block;
  //   height: 2px;
  //   background:  url("~@/assets/img/btn_tap_home.png") left bottom no-repeat;
  //   background-size:100%;
  //   z-index: 1;
  // }
  
  .menu-item.menu-item-on::after{
    position: absolute;
    left: 50%;
    content: " ";
    display: block;
    height: 2px;
    margin-left:-60px;
    width: 120px;
    background: linear-gradient(to left, rgba(277,213,167,0),#D2BF89, rgba(195, 171, 110,.05) );
    opacity: 0.77;
    z-index: 1;
  }
  .menu-item.menu-item-on::before{
    position: absolute;
    bottom: -3px;
    left: 39%;
    transform: translateY(-50%);
    width: 24px;
    content: " ";
    display: block;
    height: 2px;
    background: #78663C;
    border-radius: 13px;
  }
}
.is-menu-shadow{
  width:100%;
  position: relative;
  &:before{
    z-index: 9;
    position: absolute;
    top:0;
    left:0;
    content: '';
    width:100%;
    height: 168px;
    opacity: 0.71;
    background-image: linear-gradient(180deg, #000000 0%, rgba(1,1,0,0.76) 29%, rgba(8,6,1,0.11) 82%, rgba(8,7,1,0.00) 100%);
  }
}
.is-menu-shadow .nav{
  position: fixed;
  transform: translateX(-50%);
  left: 46%;
  top: 45px;
}
.menu-other{
  position: fixed;
  z-index: 2001;
}
.is-menu-shadow:before{
  position: fixed;
  top: 45px;
}
</style>


